// FaqSection.jsx
import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqs = [
  {
    id: "panel1",
    q: " What is WaveLight Plus technology?",
    a:
      " WaveLight Plus is an advanced laser vision correction technology designed to improve precision and personalization in refractive procedures. It supports customized treatment planning based on individual eye measurements.",
  },
  {
    id: "panel2",
    q: "Who is eligible for WaveLight Plus treatment?",
    a:
      " Eligibility depends on eye health, corneal thickness, and refractive stability. A comprehensive evaluation is conducted to determine suitability.",
  },
  {
    id: "panel3",
    q: "Is WaveLight Plus a safe procedure?",
    a:
      "The procedure follows strict clinical protocols and uses advanced laser systems to ensure safety and accuracy. Detailed pre-operative assessments are performed before treatment.",
  },
  {
    id: "panel4",
    q: "How long does the procedure take?",
    a:
      "The laser treatment itself is typically completed within minutes per eye. Patients are monitored before and after the procedure for safety.",
  },
  {
    id: "panel5",
    q: "What is the recovery time after WaveLight Plus?",
    a:
      " Most patients experience quick visual recovery, though complete stabilization may take a few weeks. Follow-up visits are scheduled to monitor healing.",
  },
  {
    id: "panel6",
    q: "Are there any risks involved?",
    a:
      " As with any laser procedure, potential risks are discussed during consultation. Proper screening and post-operative care help minimize complications.",
  },
  {
    id: "panel7",
    q:  " How can I book a consultation for WaveLight Plus?",
    a:
      " Appointments can be scheduled online or by contacting the hospital directly for a detailed eye evaluation."
  },
];

const FaqSection = () => {
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { md: 12, xs: 8 },
        px: { md: 14, xs: 3 },
        backgroundColor: "#fff",
      }}
    >
      {/* Title */}
      <Box sx={{ textAlign: "center", mb: { md: 5, xs: 4 } }}>
        <Typography
          sx={{ fontSize: { md: "32px", xs: "22px" }, fontWeight: 800 }}
        >
          Frequently Asked Question
        </Typography>

        {/* small underline */}
        <Box
          sx={{
            height: 3,
            width: 84,
            backgroundColor: "#2EAD9F",
            borderRadius: 2,
            margin: "10px auto 0",
          }}
        />

        <Typography sx={{ fontSize: 13, mt: 1, color: "#666" }}>
          Got questions? We’ve got answers.
        </Typography>
      </Box>

      {/* Accordions container */}
      <Box sx={{ maxWidth: 1100, mx: "auto" }}>
        {faqs.map((f, idx) => {
          const isFirst = idx === 0;
          const isExpanded = expanded === f.id;
          return (
            <Accordion
              key={f.id}
              expanded={isExpanded}
              onChange={handleChange(f.id)}
              elevation={0}
              sx={{
                boxShadow: "0 6px 18px rgba(19,22,24,0.04)",
                borderRadius: "10px",
                mb: 2.5,
                "&:before": { display: "none" }, // remove default divider
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#2EAD9F" }} />}
                aria-controls={`${f.id}-content`}
                id={`${f.id}-header`}
                sx={{
                  minHeight: 64,
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                    alignItems: "center",
                  },
                  px: { md: 4, xs: 3 },
                  py: { md: 1.5, xs: 1 },
                  // first (expanded by default) style: teal header background and rounded top corners
                  ...(isExpanded && {
                    backgroundColor: "#BEEDE6", // light teal for expanded header
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }),
                }}
              >
                <Typography sx={{ fontWeight: 700 }}>{f.q}</Typography>
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  px: { md: 4, xs: 3 },
                  pt: 2.5,
                  pb: 3,
                  backgroundColor: isExpanded ? "#fff" : "#fff",
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              >
                <Typography sx={{ color: "#5f6468", lineHeight: 1.8 }}>
                  {f.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Box>
  );
};

export default FaqSection;
